<template lang="pug">
  .component-client-registration
    form(v-on:submit.prevent='formSubmit', enctype='multipart/form-data')
      .row
        h2 Personal information
      .row
        .small-12.large-4.columns
          label Client Type &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            select(v-model='body.client_type_id')
              option(:value="null" selected) Choose a client type
              option(:value='v.id', v-for='v in clientTypes') {{ v.code }}
        .small-12.large-4.columns
          label Name &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.name' required)
        .small-12.large-4.columns
          label Surname &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.surname' required)
      .row
        .small-12.large-4.columns
          label Email &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder="", v-model='body.email' required)
        .small-12.large-4.columns
          label Phone &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='international prefix call (ex: +39-3951231231)', v-model='body.phone' required)
      .row
        .small-12.large-4.columns
          label Mobile &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='international prefix call (ex: +39-3951231231)', v-model='body.mobile' required)
        .small-12.large-4.columns
          label Birthdate &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            date-picker(v-model='body.birthdate' placeholder='insert date')
        .small-12.large-4.columns
          label Fiscal code &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.fiscal_code')
      .row(v-if='isBusinessAccount')
        .small-12.large-6.columns
          label Vat number &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.vat_number' required)
        .small-12.large-6.columns
          label Organization name &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.organization_name' required)
      .row.column
        hr
        h2 Residential Address
      .row
        .columns
          label Street name &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.address.street' required)
      .row
        .small-12.large-4.columns
          label City &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.address.city' required)
        .small-12.large-3.columns
          label Region &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.address.region' required)
        .small-12.large-3.columns
          label Country &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star

            selectize-country(@optionSelected="setAddressCountry")
        .small-12.large-2.columns
          label Postal code &nbsp;
            tooltip(:open="true", :position="'right'", :tip="'Field Required'")
              span.fa.fa-star
            input(type='text', placeholder='', v-model='body.address.postal_code' required)
      .row
        .small-12.large-4.large-offset-3.columns
          label Is billing address the same as the residential address?
        .small-12.large-4.columns
          .switch.large
            input#yes-no.switch-input(type='checkbox', v-model='address')
            label.switch-paddle(for='yes-no')
              span.switch-active(aria-hidden='true') Yes
              span.switch-inactive(aria-hidden='true') No
      div(v-if='!address')
        .row
          h2 Billing address
        .row
          .columns
            label Street name &nbsp;
              tooltip(:open="true", :position="'right'", :tip="'Field Required'")
                span.fa.fa-star
              input(type='text', placeholder='', v-model='body.billing_address.street' required)
        .row
          .small-12.large-4.columns
            label City &nbsp;
              tooltip(:open="true", :position="'right'", :tip="'Field Required'")
                span.fa.fa-star
              input(type='text', placeholder='', v-model='body.billing_address.city' required)
          .small-12.large-3.columns
            label Region &nbsp;
              tooltip(:open="true", :position="'right'", :tip="'Field Required'")
                span.fa.fa-star
              input(type='text', placeholder='', v-model='body.billing_address.region' required)
          .small-12.large-3.columns
            label Country &nbsp;
              tooltip(:open="true", :position="'right'", :tip="'Field Required'")
                span.fa.fa-star
              selectize-country(@optionSelected="setBillingAddressCountry")
          .small-12.large-2.columns
            label Postal code &nbsp;
              tooltip(:open="true", :position="'right'", :tip="'Field Required'")
                span.fa.fa-star
              input(type='text', placeholder='', v-model='body.billing_address.postal_code' required)
      hr
      .row
        .small-12.large-4.large-offset-3.columns
          label Add document?
        .small-12.large-4.columns
          .switch.large
            input#add-document.switch-input(type='checkbox', v-model='document')
            label.switch-paddle(for='add-document')
              span.switch-active(aria-hidden='true') Yes
              span.switch-inactive(aria-hidden='true') No

      backoffice-driver-license-create(@driverLicenseUpdated="setDriverLicenseFields", v-if="document")
      .row
        .columns
          ClientExtraFields(:fields="body.extra")
      .row
        .columns.text-center
          label
            input.button(type='submit')

</template>
<script type="text/babel">
import Dropzone from 'components/structure/Dropzone'
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import DatePicker from 'components/structure/DatePicker'
import CountryList from 'src/CountryList'
import AlertBox from 'components/structure/AlertBox'
import Reveal from 'components/structure/foundation/Reveal'
import BackofficeDriverLicenseCreate from './CreateDriverLicense'
import SelectizeCountry from '../../components/structure/ui/lists/selectize/SelectizeCountry'
import ClientExtraFields from '../../components/structure/ui/ClientExtraFields'
import {mapState} from 'vuex'
import Tooltip from 'components/structure/foundation/Tooltip'

export default {
  name: 'BackofficeClientRegistration',
  components: {
    Tooltip,
    ClientExtraFields,
    SelectizeCountry,
    BackofficeDriverLicenseCreate,
    DatePicker,
    Dropzone,
    AlertBox,
    Reveal
  },
  data() {
    return {
      address: true,
      document: false,
      clientTypes: [],
      body: {
        extra: {},
        client_type_id: null,
        name: null,
        surname: null,
        email: null,
        mobile: null,
        birthdate: null,
        fiscal_code: null,
        vat_number: null,
        organization_name: null,
        address: {
          country: null,
          region: null,
          city: null,
          postal_code: null,
          street: null
        },
        billing_address: {
          country: null,
          region: null,
          city: null,
          postal_code: null,
          street: null
        },
        accepted_tocs_id: []
      },

    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    countryList() {
      var list = []
      $.map(CountryList.countries, function (obj) {
        list.push({id: obj.name, text: obj.name})
      })
      return list
    },
    isBusinessAccount() {
      const clientType = this.clientTypes.find((item) => {
        return item.id === this.body.client_type_id
      })

      return clientType && clientType.type === 'BUSINESS'
    }
  },
  mounted() {
    this.configuration.system.system_client_custom_fields.value.forEach((item) => {
      this.$set(this.body.extra, item.value, null)
    })
  },
  created() {
    KeplerBackofficeSdk.clientTypes.list(1, 1000, null).all((data) => {
      this.clientTypes = data.clientTypes
    })
  },
  methods: {
    setAddressCountry(country) {
      this.body.address.country = country.name
    },
    setBillingAddressCountry(country) {
      this.body.billing_address.country = country.name
    },
    setDriverLicenseFields(driverLicense) {
      this.body.document = driverLicense
    },

    uploaded: function (file, response) {
      this.body.document.attachments.push(response.token)
    },
    formSubmit: function (val) {

      if (this.document) {
        var propNames = Object.getOwnPropertyNames(this.body.document)
        for (var i = 0; i < propNames.length; i++) {
          var propName = propNames[i]
          if (this.body.document[propName] === '' || this.body.document[propName] === null || this.body.document[propName] === undefined) {
            delete this.body.document[propName]
          }
        }
      }else{
        delete this.body.document
      }



      if (this.address) {
        this.body.billing_address = this.body.address
      }

      if (!this.isBusinessAccount) {
        this.body.organization_name = this.body.name + ' ' + this.body.surname
      }

      KeplerBackofficeSdk.clients.make(this.body, (data) => {
        this.$router.push({name: 'client', params: {id: data.client_id}})
      })
    },
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
.has-tip
  border-bottom: 0px !important

</style>



// WEBPACK FOOTER //
// CreateClient.vue?28f7b1b0